import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import '../styles/ItemDetailPage.css';

const ItemDetailPage = ({ cart, updateCart }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [selectedColor, setSelectedColor] = useState('');
  const [selectedSize, setSelectedSize] = useState('');
  const [item, setItem] = useState(null);

  useEffect(() => {
    if (state?.item) {
      setItem(state.item);
      if (state.item.colors?.length) setSelectedColor(state.item.colors[0]);
      if (state.item.sizes?.length) setSelectedSize(state.item.sizes[0]);
    } else {
      navigate('/items');
    }
  }, [state, navigate]);

  const handleAddToCart = () => {
    if (!item) return;

    const newItem = {
      ...item,
      selectedColor: selectedColor || null,
      selectedSize: selectedSize || null
    };

    const updatedCart = { ...cart };

    // Determine where to place the item based on current cart state
    if (!updatedCart.firstChoice) {
      updatedCart.firstChoice = newItem;
    } else if (item.tier === 'tier1' && !updatedCart.secondChoice && state?.currentStep === 1) {
      // Only allow second tier1 item in step 1
      updatedCart.secondChoice = newItem;
    } else if (state?.currentStep === 2) {
      updatedCart.secondChoice = newItem;
    } else if (state?.currentStep === 3) {
      updatedCart.thirdChoice = newItem;
    }

    updateCart(updatedCart);
    navigate('/items');
  };

  if (!item) return <div className="loading">Loading item...</div>;

  return (
    <div className="item-detail-container">
      <button className="back-button" onClick={() => navigate('/items')}>
        ← Back to Items
      </button>

      <div className="item-detail-card">
        {/* ... rest of your item detail UI ... */}
        <button
          className="add-to-cart-button"
          onClick={handleAddToCart}
        >
          Add to Cart
        </button>
      </div>
    </div>
  );
};

export default ItemDetailPage;